'use client';

import React from 'react';
import ProfileAvatar from './profile-avatar';
import ProfileField from './profile-field';
interface ProfileCardProps {
  name: string;
  phone: string;
  email?: string;
  aadhaarNumber?: string;
  address?: string;
  dateOfBirth?: string;
  profileImage?: string;
}
function ProfileCard({
  name,
  phone,
  profileImage
}: ProfileCardProps) {
  const handleUpload = () => {
    // Handle upload functionality
    // console.log('Upload clicked');
  };
  return <div className="w-full max-w-md overflow-hidden rounded-xl bg-white shadow-lg md:mb-5" data-sentry-component="ProfileCard" data-sentry-source-file="profile-card.tsx">

      <div className="flex justify-center">
        <ProfileAvatar imageUrl={profileImage} onUpload={handleUpload} name={name} data-sentry-element="ProfileAvatar" data-sentry-source-file="profile-card.tsx" />
      </div>

      <div className="divide-y divide-gray-200">
        <ProfileField label="Name" value={name} required data-sentry-element="ProfileField" data-sentry-source-file="profile-card.tsx" />
        <ProfileField label="Phone number" value={phone} required data-sentry-element="ProfileField" data-sentry-source-file="profile-card.tsx" />
        {/* FIXME : Uncomment later when user data is available */}
        {/* <ProfileField
          label="Mail"
          value={email}
          required
         />
         <ProfileField
          label="Aadhaar Number"
          value={aadhaarNumber}
         />
         <ProfileField
          label="Address"
          value={address}
         />
         <ProfileField
          label="Date of Birth"
          value={dateOfBirth}
         /> */}
      </div>
    </div>;
}
;
export default ProfileCard;